import { UseFormRegister } from "react-hook-form";

import { NumberInput } from "../shared/Inputs/NumberInput";
import { PartTagFormValues } from "../../utils/partTagFields";

interface PartTagSizeInputsProps {
  register: UseFormRegister<PartTagFormValues>;
}

export default function PartTagSizeInputs({ register }: PartTagSizeInputsProps) {
  return (
    <div className="rounded-md border border-gray-200 bg-white p-3">
      <h2 className="text-sm font-semibold text-gray-900">Size</h2>
      <p className="text-xs text-gray-500 mt-0.5">The label is designed at 10 x 5 cm and scales to fit other sizes.</p>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <NumberInput label="Width (cm)" register={register} registerName="display.widthCm" step="0.1" min={0.1} />
        <NumberInput label="Height (cm)" register={register} registerName="display.heightCm" step="0.1" min={0.1} />
      </div>
    </div>
  );
}
